import PropTypes from 'prop-types';

import { LogoExpand } from './styled';

const ExpandMenuOpen = ({ size }) => (
  <LogoExpand size={size}>
    <span />
    <span />
    <span />
  </LogoExpand>
);

ExpandMenuOpen.propTypes = {
  size: PropTypes.string,
};

ExpandMenuOpen.defaultProps = {
  size: '20px',
};

export default ExpandMenuOpen;
